import offsetParent from './offset-parent';
import elementScrollPosition from './element-scroll-position';

export default function parentScrollPosition(element) {
    var parent = offsetParent(element);

    return parent ? elementScrollPosition(parent) : { x: 0, y: 0 };
}



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-popup-common/dist/es/parent-scroll-position.js
// module id = ../../../../@progress/kendo-popup-common/dist/es/parent-scroll-position.js
// module chunks = 3